import React, { Component } from "react";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Table,
  Input,
  Button,
  FormGroup,
  Label
} from "reactstrap";

import AdminSingleDefinition from "./AdminSingleDefinition";
import AdminPriceDefinitionListStyles from "./AdminPriceDefinitionList.css";
import Checkbox from "react-simple-checkbox";

import utilities from "./Utilities";
let Utilities = new utilities();

class AdminPriceDefinitionList extends Component {
  state = {
    items: [],
    isChecked: false
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getDefinitions();
  }

  getDefinitions = () => {
    axios.get(`/api/admin-settings/${this.props.dbgroup}`).then(res => {
      this.setState({
        items: res.data.data
      });
    });
  };

  onInputChange = (e, oversizedId, oversizedBooleon) => {
    let id = "";
    let modifiedField = "";
    let modifiedFieldValue = "";

    if (oversizedId) {
      id = oversizedId;
      modifiedField = "oversizedMattColor";
      modifiedFieldValue = oversizedBooleon;
    } else {
      let row = e.target.parentNode.parentNode;
      id = row.id;
      modifiedField = e.target.dataset.field;
      modifiedFieldValue = e.target.value;
    }

    console.log(oversizedBooleon);

    if (id === "new") {
      return;
    }

    let items = this.state.items;

    let modifiedItem = items.filter(item => item._id === id)[0];
    modifiedItem[modifiedField] = modifiedFieldValue;

    // TODO apply without reply
    //let rest = items.filter(item => item._id != id)

    delete modifiedItem._id;
    delete modifiedItem.__v;

    console.log(modifiedItem);

    axios
      .put(
        `/api/admin-settings/${id}`,
        {
          settings: modifiedItem
        },
        {
          headers: {
            Authorization: "Token " + localStorage.getItem("authToken")
          }
        }
      )
      .then(res => {
        this.getDefinitions();
      });
  };

  addDefinition = () => {
    let boilerPlate = {
      _id: "new"
    };

    for (var i = 0; i < this.props.fields.length; i++) {
      let prop = this.props.fields[i];
      boilerPlate[prop] = "";
    }

    let items = [...this.state.items, boilerPlate];

    this.setState({
      items: items
    });

    delete boilerPlate._id;
    boilerPlate.type = this.props.dbgroup;

    boilerPlate.oversizedMattColor = false;
    console.log(boilerPlate);

    axios
      .post(
        "/api/admin-settings",
        {
          settings: boilerPlate
        },
        {
          headers: {
            Authorization: "Token " + localStorage.getItem("authToken")
          }
        }
      )
      .then(res => {
        this.getDefinitions();
      })
      .catch(error => {
        console.log(error.response);
      });
  };

  deleteDefinition = e => {
    let id = e.target.parentNode.parentNode.id;

    if (this.state.items.length < 2) {
      // There has to be at least one definition
      return;
    }

    if (id === "new") {
      // TODO remove from list
      return;
    }

    axios
      .delete(`/api/admin-settings/${id}`, {
        headers: {
          Authorization: "Token " + localStorage.getItem("authToken")
        }
      })
      .then(res => {
        this.getDefinitions();
      });
  };

  render() {
    let readOnlyFields = this.props.readOnlyFields || [];

    let deleteTableHeader = <th>Delete</th>;
    let deleteTableButton = (
      <th>
        {" "}
        <Button
          className='delete-btn'
          onClick={e => {
            if (window.confirm("Are you sure you want to delete this?"))
              this.deleteDefinition(e);
          }}
        >
          Delete
        </Button>{" "}
      </th>
    );

    if (readOnlyFields.indexOf("delete") > -1) {
      deleteTableHeader = null; // <th></th>
      deleteTableButton = null; // <th></th>
    }

    let addButton = <Button onClick={this.addDefinition}>Add</Button>;

    if (this.props.hideAddButton != null && this.props.hideAddButton) {
      addButton = "";
    }

    return (
      <div
        className='admin-container main-container'
        data-section={this.props.dbgroup || ""}
      >
        <Row>
          <Col>
            <h1>{this.props.name}</h1>
            <p>
              <i>Settings are automatically saved upon changes</i>
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            {this.props.singleFields.map(item => {
              return (
                <AdminSingleDefinition
                  db={item.dbName}
                  name={item.name}
                  strField={this.props.strField}
                />
              );
            })}
          </Col>
        </Row>

        <Row data-overflow={this.props.overflow}>
          <Col>
            <Table className='priceDefinitionTable'>
              <thead>
                <tr>
                  {this.props.fields.map(item => {
                    return (
                      <th key={item + "h"}>
                        {Utilities.capitalize(
                          item
                            .replace(
                              /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g,
                              "$1$4 $2$3$5"
                            )
                            .toLowerCase()
                        )}
                      </th>
                    );
                  })}
                  {deleteTableHeader}
                  {this.props.name === "Frames" && <th>Upload Images</th>}
                </tr>
              </thead>

              <tbody>
                {this.state.items.map(item => {
                  //   console.log(item);
                  return (
                    <tr key={item._id} id={item._id}>
                      {this.props.fields.map(field => {
                        {
                          return (
                            <th data-field={field} key={field + "b"}>
                              {field !== "oversizedMattColor" && (
                                <Input
                                  onBlur={this.onInputChange}
                                  type='text'
                                  data-field={field}
                                  defaultValue={item[field]}
                                  readOnly={readOnlyFields.indexOf(field) > -1}
                                />
                              )}

                              {field === "oversizedMattColor" && (
                                <Checkbox
                                  checked={item[field]}
                                  size={3}
                                  tickAnimationDuration={50}
                                  backAnimationDuration={100}
                                  onChange={e =>
                                    this.onInputChange(
                                      e,
                                      item._id,
                                      !item[field]
                                    )
                                  }
                                />
                              )}
                              <br />
                            </th>
                          );
                        }
                      })}

                      {deleteTableButton}

                      {this.props.name === "Frames" && (
                        <th>
                          {" "}
                          <a
                            target='_blank'
                            href={"/admin/frame-images/" + item.adminId}
                          >
                            Upload Images
                          </a>{" "}
                        </th>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {addButton}
          </Col>
        </Row>
      </div>
    );
  }
}

export default AdminPriceDefinitionList;



// WEBPACK FOOTER //
// ./src/components/AdminPriceDefinitionList.js